(function () {
  function closest(el, selector) {
    while (el && el !== document) {
      if (el.matches && el.matches(selector)) return el;
      el = el.parentNode;
    }
    return null;
  }

  function attr(el, name) {
    var v = el.getAttribute(name);
    return v == null ? "" : v;
  }

  function toPath(url) {
    try {
      return new URL(url, window.location.origin).pathname || "";
    } catch (e) {
      return "";
    }
  }

  function extractHandleFromPath(path, segment) {
    // path: /products/xxx or /collections/yyy ...
    var parts = String(path || "").split("/").filter(Boolean);
    var i = parts.indexOf(segment);
    return i >= 0 && parts[i + 1] ? parts[i + 1] : "";
  }

  function normalizeDestination(url) {
    // si href est une URL absolue du même domaine => on peut stocker le pathname
    // (plus lisible en GA4). Si tu préfères garder l'absolu, commente ce bloc.
    try {
      var u = new URL(url, window.location.origin);
      // si c'est le même host, on garde le path + query
      if (u.host === window.location.host) return u.pathname + (u.search || "");
      return u.href;
    } catch (e) {
      return url || "";
    }
  }

  document.addEventListener(
    "click",
    function (e) {
      var a = closest(e.target, "a[data-banner-id]");
      if (!a) return;

      // Valeurs brutes depuis HTML
      var banner_id = attr(a, "data-banner-id");
      var banner_name = attr(a, "data-banner-name");
      var page_type = attr(a, "data-page-type");
      var destination_raw = attr(a, "data-banner-destination") || a.href || "";

      // Normalisation destination (optionnelle)
      var banner_destination = normalizeDestination(destination_raw);

      // Handles depuis attributs (si déjà présents)
      var banner_product_handle = attr(a, "data-banner-product-handle");
      var banner_collection_handle = attr(a, "data-banner-collection-handle");
      var banner_blog_handle = attr(a, "data-banner-blog-handle");

      // Auto-déduction depuis destination si vide
      var destPath = toPath(destination_raw);

      if (!banner_product_handle) {
        banner_product_handle = extractHandleFromPath(destPath, "products");
      }
      if (!banner_collection_handle) {
        banner_collection_handle = extractHandleFromPath(destPath, "collections");
      }
      if (!banner_blog_handle) {
        banner_blog_handle = extractHandleFromPath(destPath, "blogs");
      }

      var payload = {
        banner_id: banner_id,
        banner_name: banner_name,

        banner_destination: banner_destination,
        banner_collection_handle: banner_collection_handle,
        banner_product_handle: banner_product_handle,
        banner_blog_handle: banner_blog_handle,

        page_type: page_type,
        page_location: window.location.pathname
      };

      if (typeof window.gtag === "function") {
        window.gtag("event", "internal_banner_click", payload);
      }
    },
    { capture: true }
  );
})();
